(() => {
  'use strict';

  const DEFAULT_COUNTRIES = new Set('AT,BE,BG,CZ,DE,DK,EE,ES,FI,FR,GR,HR,HU,IE,IT,LT,LU,LV,NL,PL,PT,RO,SE,SI,SK'.split(','));
  const SHIPPING_CLASSES = new Set(['standard', 'small', 'standalone_panel', 'panel_kit', 'freight']);
  const SHIPPING_MODES = new Set(['local', 'remote', 'preorder']);
  const own = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key);

  // Exact, handle-scoped cleanup for legacy delivery claims that conflict with live Smart Shipping data.
  // Price-threshold copy such as "Kostenloser Versand ab …" is deliberately outside this allowlist.
  const LEGACY_DELIVERY_RULES = [
    {
      handles: 'hoymiles-hms-1600-4t-wechselrichter-drosseln hoymiles-hms-2000-4t-wechselrichter-drosseln-auf-600w-800w hoymiles-hms-1600-4wb-hiflow-wechselrichter-drosseln-auf-600w-800w hoymiles-hms-2000-4wb-hiflow-wechselrichter-drosseln-auf-600w-800w zendure-solarflow-2400-pro-mit-4x-ab3000l-batteriespeicher zendure-solarflow-2400-pro-set-mit-4-500w-solarmodule-komplettset'.split(' '),
      old: 'Auf Lager und sofort lieferbar.',
      replacement: '',
    },
    {
      handles: 'zendure-solarflow-2400-ac-mit-2x-ab3000x zendure-solarflow-ab3000x-erweiterungsbatterie-2880wh-lifepo4-add-on zendure-solarflow-ab3000x-erweiterungsbatterie-2880wh-lifepo4-add-on-nach-rabatt'.split(' '),
      old: 'Auf Lager und sofort lieferbar!',
      replacement: '',
    },
    {
      handles: 'balkonkraftwerk-speicher-zendure-solarflow-set-960wh-7680wh zendure-solarflow-pvhub-mit-1x-zendure-ab2000'.split(' '),
      old: 'AB2000 Batterien, Hub1200s und Hub2000s sind schon auf Lager und sofort lieferbar.',
      replacement: '',
    },
    {
      handles: ['zendure-solarflow-set-5760wh-smart-pv-hub-1200-mit-3x-zendure-solarflow-ab-2000'],
      old: 'AB2000S Batterien, Hub1200s und Hub2000s sind schon auf Lager und sofort lieferbar.',
      replacement: '',
    },
    {
      handles: ['zendure-solarflow-ab-2000-erweiterungsbatterie-1920wh-add-on-lifepo4'],
      old: 'Auf Lager und sofort lieferbar! Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind. Zendure stellt das Produkt AB2000 nicht mehr her, und das Modell AB2000X hat das Modell AB2000S vollständig ersetzt.',
      replacement: 'Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind. Zendure stellt das Produkt AB2000 nicht mehr her, und das Modell AB2000X hat das Modell AB2000S vollständig ersetzt.',
    },
    {
      handles: 'huawei-luna2000-7-s1-energiespeichersystem huawei-luna2000-14-s1-energiespeichersystem-13-8kwh huawei-luna2000-21-s1-energiespeichersystem'.split(' '),
      old: 'Lagerware! Auf Lager und sofort lieferbar!',
      replacement: '',
    },
    {
      handles: 'zendure-solarflow-set-1920wh-hyper-2000-mit-1x-zendure-ab2000 zendure-solarflow-hyper-2000-mit-1x-zendure-ab2000 zendure-solarflow-ab2000x-erweiterungsbatterie-1920wh-lifepo4-add-on'.split(' '),
      old: 'Auf Lager und sofort lieferbar! Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind.',
      replacement: 'Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind.',
    },
    {
      handles: ['zendure-solarflow-ab2000s-erweiterungsbatterie-1920wh-add-on-lifepo4'],
      old: 'Auf Lager und sofort lieferbar! Wir werden Ihnen genau AB2000S-Batterien zusenden.',
      replacement: 'Wir werden Ihnen genau AB2000S-Batterien zusenden.',
    },
    {
      handles: ['anker-solix-solarbank-2-e1600-pro-speicher-3200wh-komplettset'],
      old: 'Anker SOLIX Solarbank 2 E1600 Pro Kmplettset - Auf Lager und sofort lieferbar.',
      replacement: 'Anker SOLIX Solarbank 2 E1600 Pro Kmplettset',
    },
    {
      handles: ['zendure-solarflow-hyper-2000-hy-brid-wech-sel-rich-ter-nach-rabatt'],
      old: 'Zendure Hyper 2000 - Nicht nur für Indach Photovoltaik, sondern auch für Balkonkraftwerk. Auf Lager und sofort lieferbar!',
      replacement: 'Zendure Hyper 2000 - Nicht nur für Indach Photovoltaik, sondern auch für Balkonkraftwerk.',
    },
    {
      handles: ['zendure-solarflow-ab2000s-erweiterungsbatterie-1920wh-add-on-lifepo4-nach-rabatt'],
      old: 'Auf Lager und sofort lieferbar! Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind. Zendure stellt das Produkt AB2000S nicht mehr her, und das Modell AB2000X hat das Modell AB2000S vollständig ersetzt.',
      replacement: 'Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind. Zendure stellt das Produkt AB2000S nicht mehr her, und das Modell AB2000X hat das Modell AB2000S vollständig ersetzt.',
    },
    {
      handles: ['zendure-solarflow-ab-2000-erweiterungsbatterie-1920wh-add-on-lifepo4-nach-rabatt'],
      old: 'Auf Lager und sofort lieferbar! Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind. Zendure stellt das Produkt AB2000 nicht mehr her, und das Modell AB2000X hat das Modell AB2000S vollständig ersetzt.',
      replacement: 'Wir werden Ihnen die neuesten AB2000X-Batterien zusenden, die über das neueste Design verfügen und vollständig kompatibel mit AB2000 und AB2000S sind. Zendure stellt das Produkt AB2000 nicht mehr her, und das Modell AB2000X hat das Modell AB2000S vollständig ersetzt.',
    },
    {
      handles: ['anker-solix-solarbank-2-e1600-pro-3200wh-komplettset-vorbestellung'],
      old: 'Anker SOLIX Solarbank 2 E1600 Pro 4300 Wh Komplettset - Auf Lager und sofort lieferbar.',
      replacement: 'Anker SOLIX Solarbank 2 E1600 Pro 4300 Wh Komplettset',
    },
    {
      handles: 'zendure-solarflow-2400-ac-batteriespeicher zendure-solarflow-2400-ac-mit-1x-ab3000x zendure-solarflow-2400-ac-mit-3x-ab3000x'.split(' '),
      old: 'Zendure SolarFlow 2400 AC - Auf Lager und sofort lieferbar!',
      replacement: 'Zendure SolarFlow 2400 AC',
    },
    {
      handles: ['anker-solix-solarbank-2-e1600-pro-anker-solix-bp2700'],
      old: 'Anker SOLIX Solarbank 2 E1600 Pro + Anker SOLIX BP2700 - Auf Lager und sofort lieferbar.',
      replacement: 'Anker SOLIX Solarbank 2 E1600 Pro + Anker SOLIX BP2700',
    },
    {
      handles: 'zendure-solarflow-2400-pro-bidirektionaler-ac-speicher zendure-solarflow-2400-pro-mit-1x-ab3000l-bidirektional-batteriespeicher zendure-solarflow-2400-pro-mit-3x-ab3000l-bidirektional-ac-batteriespeicher'.split(' '),
      old: 'Zendure SolarFlow 2400 Pro - Auf Lager und sofort lieferbar.',
      replacement: 'Zendure SolarFlow 2400 Pro',
    },
    {
      handles: ['zendure-solarflow-2400-pro-mit-2x-ab3000l-bidirektionaler-ac-speicher'],
      old: 'Zendure SolarFlow 2400 Pro mit 2x AB3000L. Auf Lager und sofort lieferbar.',
      replacement: 'Zendure SolarFlow 2400 Pro mit 2x AB3000L.',
    },
    {
      handles: ['anker-solix-c2000-gen-2-portable-power-station-2048wh-2400w'],
      old: 'Anker SOLIX C2000 Gen 2 Portable Power Station. Auf Lager und sofort lieferbar!',
      replacement: 'Anker SOLIX C2000 Gen 2 Portable Power Station.',
    },
    {
      handles: 'anker-solix-solarbank-3-e2700-pro anker-solix-solarbank-3-e2700-pro-speicher-8-04kwh-komplettset anker-solix-solarbank-3-e2700-pro-speicher-2-68kwh-komplettset anker-solix-solarbank-3-e2700-pro-speicher-2-68kwh-mit-smart-meter anker-solix-solarbank-3-e2700-pro-bp2700-smart-meter anker-solix-solarbank-3-pro-speicher-bp2700-erweiterungsakku anker-solix-solarbank-3-e2700-pro-bp2700-smart-meter-2'.split(' '),
      old: 'Alle Waren sind auf Lager und sofort lieferbar. Die Anker Solix Solarbank 3 Lieferzeit beträgt voraussichtlich 2-3 Werktage.',
      replacement: '',
    },
    {
      handles: 'anker-solix-bp2700-erweiterungsakku-fur-solarbank-2-3 anker-solix-bp2700-erweiterungsakku-fur-solarbank-2-3-nach-rabatt'.split(' '),
      old: 'Alle Waren sind auf Lager und sofort lieferbar. Die Anker Solix BP2700 Lieferzeit beträgt voraussichtlich 2-3 Werktage.',
      replacement: '',
    },
    {
      handles: 'anker-solix-solarbank-3-e2700-pro-speicher-5-36-kwh-komplettset anker-solix-solarbank-3-e2700-pro-speicher-10-72kwh-komplettset'.split(' '),
      old: 'Anker SOLIX Solarbank 3 E2700 Pro Speicher Komplettset - Alle Waren sind auf Lager und sofort lieferbar. Die Anker Solix Solarbank 3 Lieferzeit beträgt voraussichtlich 2-3 Werktage.',
      replacement: 'Anker SOLIX Solarbank 3 E2700 Pro Speicher Komplettset',
    },
    {
      handles: ['hoymiles-hms-1000-2wb-hiflow-mikrowechselrichter-wifi-integriert'],
      old: 'Auf Lager! Lieferzeit 2 - 3 Werktage.',
      replacement: '',
    },
    {
      handles: ['hoymiles-erweiterungsset-mit-verbindungskabel'],
      old: 'Hoymiles Erweiterungsset mit Verbindungskabel. Lieferzeit: 2 - 3 Werkage!',
      replacement: 'Hoymiles Erweiterungsset mit Verbindungskabel.',
    },
    {
      handles: ['hoymiles-hms-800-2wb-hiflow-mikrowechselrichter'],
      old: 'Vorbestellung: ab 20.07.2026.',
      replacement: '',
    },
    {
      handles: ['hoymiles-hms-1800-4wb-hiflow-wechselrichter-drosseln-auf-600w-800w'],
      old: 'Vorbestellung – Liefertermin wird bekannt gegeben.',
      replacement: '',
    },
    {
      handles: 'anker-solix-solarbank-max-ac-ac-gekoppelter-heimspeicher anker-solix-solarbank-max-ac-bp7000-x1-plug-play-komplettset'.split(' '),
      old: 'Anker SOLIX Solarbank MAX AC Vorbestellung: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1× Anker SOLIX Smart Meter Gen 2 sowie 4× Anker SOLIX Smart Plugs dazu!',
      replacement: 'Anker SOLIX Solarbank MAX AC: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1× Anker SOLIX Smart Meter Gen 2 sowie 4× Anker SOLIX Smart Plugs dazu!',
    },
    {
      handles: ['anker-solix-bp7000-erweiterungsakku-fur-max-ac'],
      old: 'Anker SOLIX BP7000 Erweiterungsakku für MAX AC. Anker SOLIX BP7000 Erweiterungsakku Vorbestellung: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 2× Anker SOLIX Smart Plugs dazu!',
      replacement: 'Anker SOLIX BP7000 Erweiterungsakku für MAX AC. Anker SOLIX BP7000 Erweiterungsakku: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 2× Anker SOLIX Smart Plugs dazu!',
    },
    {
      handles: ['anker-solix-solarbank-max-ac-bp7000-x2-21kwh-plug-play-komplettset'],
      old: 'Anker SOLIX Solarbank MAX AC Vorbestellung: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1× Anker SOLIX Smart Meter Gen 2.',
      replacement: 'Anker SOLIX Solarbank MAX AC: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1× Anker SOLIX Smart Meter Gen 2.',
    },
    {
      handles: 'anker-solix-solarbank-max-ac-3-bp7000-28kwh anker-solix-solarbank-max-ac-bp7000-x4-35kwh-plug-play-komplettset anker-solix-solarbank-max-ac-1-bp7000-14kwh-plug-play-set-nach-rabatt'.split(' '),
      old: 'Anker SOLIX Solarbank MAX AC Vorbestellung: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1× Anker SOLIX Smart Meter Gen 2!',
      replacement: 'Anker SOLIX Solarbank MAX AC: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1× Anker SOLIX Smart Meter Gen 2!',
    },
    {
      handles: ['anker-solix-solarbank-max-ac-7-42kwh-plug-play-komplettset'],
      old: 'Anker SOLIX Solarbank Max AC 7-42 kWh Plug&Play Komplettset. Anker SOLIX Solarbank MAX AC Vorbestellung: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1×Anker SOLIX Smart Meter Gen 2!',
      replacement: 'Anker SOLIX Solarbank Max AC 7-42 kWh Plug&Play Komplettset. Anker SOLIX Solarbank MAX AC: Profitieren Sie von unserer exklusiven Vorverkaufsaktion und erhalten Sie kostenlos 1×Anker SOLIX Smart Meter Gen 2!',
    },
  ];
  const legacyDeliveryRuleByHandle = new Map();
  LEGACY_DELIVERY_RULES.forEach((rule) => rule.handles.forEach((handle) => legacyDeliveryRuleByHandle.set(handle, rule)));
  const LEGACY_SPACE = new Set([' ', '\t', '\n', '\r', '\f', '\u00a0']);

  const legacyDeletionRange = (oldText, newText) => {
    let start = 0;
    while (start < oldText.length && start < newText.length && oldText[start] === newText[start]) start += 1;
    let suffix = 0;
    while (
      suffix < oldText.length - start
      && suffix < newText.length - start
      && oldText[oldText.length - 1 - suffix] === newText[newText.length - 1 - suffix]
    ) suffix += 1;
    const end = oldText.length - suffix;
    return start < end && oldText.slice(0, start) + oldText.slice(end) === newText
      ? { start, end }
      : null;
  };

  if (legacyDeliveryRuleByHandle.size !== 57) throw new Error('[Mini Power Shipping] Expected 57 exact description cleanup rules.');
  legacyDeliveryRuleByHandle.forEach((rule, handle) => {
    if (
      !handle
      || !rule
      || typeof rule.old !== 'string'
      || typeof rule.replacement !== 'string'
      || rule.old.includes('Kostenloser Versand ab')
      || rule.replacement.includes('Kostenloser Versand ab')
      || !legacyDeletionRange(rule.old, rule.replacement)
    ) {
      throw new Error(`[Mini Power Shipping] Invalid exact description cleanup rule: ${handle}`);
    }
  });

  const readLegacyBlockText = (element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let raw = '';
    let node;
    while ((node = walker.nextNode())) {
      const start = raw.length;
      raw += node.data;
      nodes.push({ node, start, end: raw.length });
    }

    const chars = [];
    const ranges = [];
    let index = 0;
    while (index < raw.length) {
      if (LEGACY_SPACE.has(raw[index])) {
        const start = index;
        while (index < raw.length && LEGACY_SPACE.has(raw[index])) index += 1;
        if (chars.length && index < raw.length) {
          chars.push(' ');
          ranges.push([start, index]);
        }
      } else {
        chars.push(raw[index]);
        ranges.push([index, index + 1]);
        index += 1;
      }
    }
    return { text: chars.join(''), ranges, nodes };
  };

  const deleteLegacyRawRange = (nodes, start, end) => {
    nodes.forEach((span) => {
      const from = Math.max(start, span.start);
      const to = Math.min(end, span.end);
      if (from < to) span.node.deleteData(from - span.start, to - from);
    });
  };

  const auditLegacyCleanup = (detail) => {
    const record = Object.freeze({
      version: 'mp-description-cleanup-v1',
      targetThemeId: '199771291995',
      at: new Date().toISOString(),
      ...detail,
    });
    window.__MP_DESCRIPTION_CLEANUP_AUDIT__ = record;
    window.dispatchEvent(new CustomEvent('mp:description-cleanup', { detail: record }));
    return record;
  };

  const cleanLegacyDeliveryClaim = (root) => {
    const actualThemeId = String(window.Shopify?.theme?.id || '199771291995');
    if (actualThemeId !== '199771291995') {
      auditLegacyCleanup({ status: 'skipped-theme', actualThemeId });
      return;
    }

    const handle = String(root.dataset.mpProductHandle || '');
    const rule = legacyDeliveryRuleByHandle.get(handle);
    if (!rule) return;

    const matches = [...root.querySelectorAll('p, div, li')]
      .filter((block) => !block.querySelector('p, div, li'))
      .map((block) => ({ block, reading: readLegacyBlockText(block) }))
      .filter(({ reading }) => reading.text === rule.old);
    if (matches.length !== 1) {
      root.dataset.mpDescriptionCleanup = 'skipped';
      auditLegacyCleanup({ status: 'skipped-exact-match-count', handle, count: matches.length });
      console.error('[Mini Power Shipping] Exact legacy delivery block count was not one.', handle, matches.length);
      return;
    }

    const { block, reading } = matches[0];
    if (!rule.replacement) {
      block.remove();
    } else {
      const cut = legacyDeletionRange(rule.old, rule.replacement);
      const snapshot = block.innerHTML;
      const rawStart = reading.ranges[cut.start][0];
      const rawEnd = reading.ranges[cut.end - 1][1];
      deleteLegacyRawRange(reading.nodes, rawStart, rawEnd);
      if (readLegacyBlockText(block).text !== rule.replacement) {
        block.innerHTML = snapshot;
        root.dataset.mpDescriptionCleanup = 'rolled-back';
        auditLegacyCleanup({ status: 'rolled-back-verification', handle });
        console.error('[Mini Power Shipping] Legacy delivery cleanup verification failed and was rolled back.', handle);
        return;
      }
    }

    root.dataset.mpDescriptionCleanup = 'applied';
    auditLegacyCleanup({ status: 'applied', handle });
  };

  const todayUtc = (now = new Date()) => now.toISOString().slice(0, 10);

  const isDateKey = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const date = new Date(`${value}T00:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
  };

  const classificationFor = (variant, classifications) => {
    if (!variant || !classifications || typeof classifications !== 'object') return null;
    const direct = classifications[String(variant.id)];
    if (direct && typeof direct === 'object') return direct;
    const taxPeer = String(variant.sku || '').match(/^MP-TAX-(\d+)$/);
    const source = taxPeer ? classifications[taxPeer[1]] : null;
    return source && typeof source === 'object' ? source : null;
  };

  const unavailable = (reason) => ({
    status: 'unavailable',
    reason,
    mode: '',
    sourceMode: '',
    minDays: null,
    maxDays: null,
    availableFrom: '',
    requiresSpedition: false,
  });

  const resolve = ({ variant = {}, classification, country = 'DE', now = new Date() } = {}) => {
    if (!classification || typeof classification !== 'object') return unavailable('unknown_variant');

    const shippingClass = classification.c === 'small_item' ? 'small' : String(classification.c || '').toLowerCase();
    const actualWeight = Number(classification.w);
    if (!SHIPPING_CLASSES.has(shippingClass) || !Number.isFinite(actualWeight) || actualWeight < 0) {
      return unavailable('invalid_classification');
    }

    const countryCode = String(country || 'DE').toUpperCase();
    const allowedCountries = classification.a == null
      ? DEFAULT_COUNTRIES
      : new Set(String(classification.a).split(',').map((value) => value.trim().toUpperCase()).filter(Boolean));
    if (!allowedCountries.has(countryCode)) return unavailable('country_not_allowed');

    const shipping = variant.shipping && typeof variant.shipping === 'object' ? variant.shipping : {};
    const hasLiveMode = own(shipping, 'mode') && String(shipping.mode || '').trim() !== '';
    const liveMode = String(shipping.mode || '').trim().toLowerCase();
    if (hasLiveMode && !SHIPPING_MODES.has(liveMode)) return unavailable('invalid_delivery_mode');
    const sourceMode = hasLiveMode ? liveMode : String(classification.l || '').trim().toLowerCase();
    if (!SHIPPING_MODES.has(sourceMode)) return unavailable('missing_delivery_mode');

    const hasLiveDate = own(shipping, 'available_from');
    const availableFrom = String(hasLiveDate ? (shipping.available_from || '') : (classification.d || '')).trim();
    const requiresSpedition = classification.s === true
      || shippingClass === 'standalone_panel'
      || shippingClass === 'panel_kit'
      || actualWeight > 40000;

    if (sourceMode === 'preorder') {
      if (isDateKey(availableFrom) && availableFrom >= todayUtc(now)) {
        return {
          status: 'ok',
          reason: '',
          mode: 'preorder',
          sourceMode,
          minDays: null,
          maxDays: null,
          availableFrom,
          requiresSpedition,
        };
      }
      return {
        status: 'ok',
        reason: availableFrom ? 'stale_preorder_date' : 'missing_preorder_date',
        mode: 'fallback',
        sourceMode,
        minDays: countryCode !== 'DE' && requiresSpedition ? 2 : 4,
        maxDays: countryCode !== 'DE' && requiresSpedition ? 8 : 7,
        availableFrom: '',
        requiresSpedition,
      };
    }

    if (sourceMode === 'remote') {
      return {
        status: 'ok',
        reason: '',
        mode: 'remote',
        sourceMode,
        minDays: 4,
        maxDays: countryCode === 'DE' ? 7 : 8,
        availableFrom: '',
        requiresSpedition,
      };
    }

    return {
      status: 'ok',
      reason: '',
      mode: 'local',
      sourceMode,
      minDays: 2,
      maxDays: countryCode === 'DE' ? (requiresSpedition ? 4 : 3) : 8,
      availableFrom: '',
      requiresSpedition,
    };
  };

  const formatDate = (value, locale = document.documentElement.lang || 'de-DE') => {
    if (!isDateKey(String(value || ''))) return String(value || '');
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(`${value}T12:00:00Z`));
  };

  const text = (result, { available = true, locale = document.documentElement.lang || 'de-DE' } = {}) => {
    const german = String(locale).toLowerCase().startsWith('de');
    if (!result || result.status !== 'ok') {
      return german ? 'Lieferzeit wird im Checkout berechnet' : 'Delivery time is calculated at checkout';
    }
    if (result.mode === 'preorder') {
      const date = formatDate(result.availableFrom, locale);
      return german ? `Versand ab ${date}` : `Ships from ${date}`;
    }
    if (!available) return german ? 'Lieferzeit: derzeit nicht verfügbar' : 'Delivery time: currently unavailable';
    return german
      ? `Voraussichtliche Lieferzeit: ${result.minDays}–${result.maxDays} Werktage`
      : `Estimated delivery time: ${result.minDays}–${result.maxDays} business days`;
  };

  const availabilityText = (result, { available = true, locale = document.documentElement.lang || 'de-DE' } = {}) => {
    const german = String(locale).toLowerCase().startsWith('de');
    if (result?.status === 'ok' && result.mode === 'preorder') {
      const date = formatDate(result.availableFrom, locale);
      return german ? `Verfügbar ab ${date}` : `Available from ${date}`;
    }
    if (!available) return german ? 'Derzeit nicht verfügbar' : 'Currently unavailable';
    return german ? 'Verfügbar' : 'Available';
  };

  const hydrateHomeCard = (card) => {
    const node = card.querySelector('[data-mp-home-delivery-data]');
    if (!node) return;
    try {
      const config = JSON.parse(node.textContent || '{}');
      const variant = config.variant || {};
      const classification = classificationFor(variant, config.classifications || {});
      const result = resolve({
        variant,
        classification,
        country: card.dataset.deliveryCountry || 'DE',
      });
      const available = Boolean(variant.available);
      const deliveryNode = card.querySelector('[data-mp-home-delivery-text]');
      const availabilityNode = card.querySelector('[data-mp-home-availability-text]');
      const shippingRow = card.querySelector('.mp-home-product-card__shipping');
      const availabilityRow = availabilityNode?.closest('.mp-home-product-card__meta-item');
      if (deliveryNode) deliveryNode.textContent = text(result, { available });
      if (availabilityNode) availabilityNode.textContent = availabilityText(result, { available });
      if (shippingRow) shippingRow.classList.toggle('mp-home-product-card__shipping--unavailable', result.status !== 'ok' || (!available && result.mode !== 'preorder'));
      if (availabilityRow) availabilityRow.classList.toggle('mp-home-product-card__meta-item--unavailable', result.status !== 'ok' || (!available && result.mode !== 'preorder'));
    } catch (error) {
      console.error('[Mini Power Shipping] Homepage delivery data could not be read.', error);
    }
  };

  const init = (scope = document) => {
    if (scope.matches?.('[data-mp-home-delivery-card]')) hydrateHomeCard(scope);
    scope.querySelectorAll?.('[data-mp-home-delivery-card]').forEach(hydrateHomeCard);
    if (scope.matches?.('[data-mp-description-fallback]')) cleanLegacyDeliveryClaim(scope);
    scope.querySelectorAll?.('[data-mp-description-fallback]').forEach(cleanLegacyDeliveryClaim);
  };

  window.MPSmartShippingDelivery = Object.freeze({
    availabilityText,
    classificationFor,
    formatDate,
    resolve,
    text,
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
